import React, { Suspense } from "react";
import LandingLayout from "./LandingLayout";

// La home ("/") es src/landing/inicio (HomeInicio) y /tactic, /pest, /sobre-nosotros, /partners, /contacto y /blog
// son las páginas de Claude Design de src/ulture (UltureSite.tsx). Aquí solo queda /apps (enlace de la bio de Instagram).
const LandingApps = React.lazy(() => import("./pages/LandingApps"));

const wrap = (children: React.ReactNode) => (
  <LandingLayout>
    <Suspense fallback={null}>{children}</Suspense>
  </LandingLayout>
);

export const LandingAppsPage = () => wrap(<LandingApps />);
